; (function ($) {

    if (!$("body").hasClass("page-template-page-3226_product_highlight")) return;

    function initSlides(slides, slideshow) {
        console.log('initSlides');
        if (slides.length > 1) {
            setInterval(function() {
                nextSlide(slideshow);
            }, 4000);
        } else {
            return false;
        }
    }

    function nextSlide(slideshow) {
        let slideCount = ($(`#${slideshow} .slide`).toArray()).length - 1;
        let currentSlide = Number($(`#${slideshow} .slide.active`).attr('data-slide'));
        $(`#${slideshow} .slide.active`).removeClass('active');
        if (currentSlide == slideCount) {
            currentSlide = 0;
        } else {
            currentSlide++;
        }
        $(`#${slideshow} .slide[data-slide="${currentSlide}"]`).addClass('active');

    }

    $(document).ready(function () {
        let slideshows = $('.slideshow').toArray();
        slideshows.map((slideshow) => {
            let slideshowId = $(slideshow).attr('id');
            let slides = $(`#${slideshowId} .slide`).toArray();
            initSlides(slides, slideshowId);
        });
    });

})(jQuery);